/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";
import {
  handleOpenComments,
} from "../../store/actions";
import { useDispatch } from "react-redux";
import comments from "./comments.PNG";
export default (props) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const handleOpenCommentsOpen = (value) => dispatch(handleOpenComments(value));
  const checkedHandler = (e) => {
    setOpen(true);
    // let colId = props.column.colId;
    // props.node.setDataValue(colId, checked);
    handleOpenCommentsOpen(true);
  };

  return (
    <><i className="fa fa-comment"></i></>
    
  );
};
